import Component from 'components/pages/PublicSurveys/PublicSurveys';
import { buildPage } from 'utils/pageHelper';
export default buildPage(Component, {
  loggedInRedirect: '/surveys',
  metaData: {
    title: 'Surveys',
    description: 'Earn money online with Qmee surveys',
  },
});
